import Icon from '../components/Icon.vue'

Icon.register({"chevron-right":{"width":320,"height":512,"paths":[{"d":"M285.5 273L91.1 467.3C81.8 476.7 66.6 476.7 57.2 467.3L34.5 444.6C25.2 435.3 25.1 420.1 34.5 410.7L188.5 256 34.5 101.3C25.1 91.9 25.2 76.7 34.5 67.4L57.2 44.7C66.6 35.3 81.8 35.3 91.1 44.7L285.5 239C294.8 248.4 294.8 263.6 285.5 273z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/chevron-right.js